var map = {
	"./ellipse-inside-blur-blue-s.svg": "a359",
	"./ellipse-inside-blur-blue.svg": "9083",
	"./ellipse-inside-blur-green-s.svg": "f1c5",
	"./ellipse-inside-blur-green.svg": "b497"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "178c";